var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var getKanbanBoardColumns = function (subTaskByStatusMap) {
    var list = [];
    subTaskByStatusMap.forEach(function (values, key) {
        list.push({
            id: key.toString(),
            itemIds: values.map(function (m) { return m.id; }),
        });
    });
    return list;
};
export var getSubTaskByStatusMap = function (subTasks) {
    if (!subTasks || subTasks.length === 0) {
        return new Map([
            [0, []],
            [1, []],
            [2, []],
        ]);
    }
    return subTasks.reduce(function (result, obj) {
        var subTasksByStatusArray = result.get(obj.status);
        if (subTasksByStatusArray) {
            result.set(obj.status, __spreadArray(__spreadArray([], subTasksByStatusArray, true), [obj], false));
        }
        else {
            result.set(obj.status, [obj]);
        }
        return result;
    }, new Map([
        [0, []],
        [1, []],
        [2, []],
    ]));
};
export var getItemStyle = function (isDragging, draggableStyle) { return (__assign({}, draggableStyle)); };
export var getContainerListStyle = function () { return ({
    height: '100%',
    width: '100%',
}); };
export var getListStyle = function (isDraggingOver) { return ({
    background: isDraggingOver ? '#dfddeb' : undefined,
    border: isDraggingOver ? '4px dashed #7564b6' : undefined,
    width: '100%',
    minHeight: '100%',
}); };
export var getUser = function (userId, users) {
    return users && userId ? users.find(function (x) { return x.id === userId; }) : null;
};
